import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureCookieConsent } from '../../../config/cookieConsent';

/*
 * Loads the brand's Cookie-Script banner once a brand route is shown (CLS or
 * ABC), skipping it for visitors coming from the brand's core website — see
 * config/cookieConsent.js. Renders nothing; the banner is the vendor's own UI.
 */
export default function CookieConsent() {
  const { pathname } = useLocation();
  useEffect(() => {
    ensureCookieConsent(pathname);
  }, [pathname]);
  return null;
}
